var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBfsi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons industries"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2188_381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#5D8DE9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2188_381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_balance",
    d: "M8.83331 28.3332V16.6665H12.1666V28.3332H8.83331ZM18.8333 28.3332V16.6665H22.1666V28.3332H18.8333ZM3.83331 34.9998V31.6665H37.1666V34.9998H3.83331ZM28.8333 28.3332V16.6665H32.1666V28.3332H28.8333ZM3.83331 13.3332V9.99984L20.5 1.6665L37.1666 9.99984V13.3332H3.83331ZM11.25 9.99984H29.75L20.5 5.4165L11.25 9.99984Z",
    fill: "#5D8DE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfsi);
export default __webpack_public_path__ + "static/media/BFSI.5f48fc41198fd474751ab0362bf73a46.svg";
export { ForwardRef as ReactComponent };